/* template */
<template minapp="mpx" xlang="wxml"><mpx-view :style="[(styles)] | transRpxStyle" @tap="handleClick" class="checkbox-icon__container" :class='[$attrs["custom-class"]]'><span class="checkbox-icon checkbox-icon__disabled custom-disabled" v-if="(disabled && !checked)"></span><div class="checkbox-icon checkbox-icon__disabled-checked custom-disabled-checked" v-else-if="(disabled && checked)"><es-icon name="check-filled" :size="(size - 6)" color="#fff"/></div><div class="checkbox-icon checkbox-icon__checked custom-checked" v-else-if="(!disabled && checked)"><es-icon name="check-filled" :size="(size - 6)" color="#fff"/></div><span class="checkbox-icon checkbox-icon__normal custom-normal" v-else-if="(!disabled && !checked)"></span></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m214602b1"}'>
  .checkbox-icon__container
    display inline-block
    .checkbox-icon
      box-sizing border-box
      display flex
      width 100%
      height 100%
      align-items center
      justify-content center
      border-radius 6px
    .checkbox-icon__disabled
      background #eeeeee
      border 1px solid #D4D3D3
    .checkbox-icon__disabled-checked
      background #eeeeee
      border 1px solid #D4D3D3
    .checkbox-icon__checked
      background #FF6400
    .checkbox-icon__normal
      border 1px solid #D4D3D3
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m214602b1"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex214602b1%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex214602b1%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m214602b1"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index214602b1/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
